import HTTP from "./http";

class APIList {
  constructor() {}
  userAuthLogin(params) {
    return HTTP.POST("api_auth/token/", params);
  }
  getProfileData() {
    return HTTP.GET("user/profile");
  }
}

export default new APIList();
